import React from "react";

import { EmailIcon } from "../../components/icons/EmailIcon";
import { ProfilePicture } from "../../components/ProfilePicture/ProfilePicture";

interface IProps {
  userData: any;
}

const AccountHeader: React.FC<IProps> = ({ userData }) => {
  let firstNameChar =
    userData?.firstName !== undefined ? userData?.firstName.charAt(0) : "";
  let lastNameChar =
    userData?.lastName !== undefined ? userData?.lastName.charAt(0) : "";
  let userName = (firstNameChar + lastNameChar).trim();

  return (
    <div className="card flex-grow-0 mb-5 mb-xl-10">
      <div className="card-body pt-9 pb-0">
        <div className="d-flex flex-wrap flex-sm-nowrap mb-3">
          <div className="me-7 mb-4">
            <div className="symbol symbol-100px symbol-lg-160px symbol-fixed position-relative">
              <ProfilePicture
                variant="medium"
                label={userName}
                firstName={userData?.firstName}
                lastName={userData?.lastName}
              />
            </div>
          </div>

          <div className="flex-grow-1">
            <div className="d-flex justify-content-between align-items-start flex-wrap mb-2">
              <div className="d-flex flex-column">
                <div className="d-flex align-items-center mb-2">
                  <label className="text-gray-800 fs-2 fw-bolder me-1">
                    {userData?.firstName} {userData?.lastName}
                  </label>
                </div>

                <div className="d-flex flex-wrap fw-bold fs-6 mb-4 pe-2">
                  <label className="d-flex align-items-center text-gray-400 mb-2">
                    <span className="me-1 d-flex align-items-center">
                      <EmailIcon />
                    </span>
                    {userData?.email}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="d-flex h-55px">
          <ul className="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap">
            <li className="nav-item">
              <Link
                className={
                  `nav-link text-active-primary me-6 ` +
                  (location.pathname === '/account/overview' && 'active')
                }
                to="/account/overview"
              >
                Overview
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className={
                  `nav-link text-active-primary me-6 ` +
                  (location.pathname === '/account/settings' && 'active')
                }
                to="/account/settings"
              >
                Settings
              </Link>
            </li>
          </ul>
        </div> */}
      </div>
    </div>
  );
};

export { AccountHeader };
